import React, { Component } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { actions, Control, Errors } from 'react-redux-form/immutable';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classnames from 'classnames';

class HtmlEditorUnwrapped extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(event, editor) {
    const { change, model, field } = this.props;
    const data = editor.getData();
    change(`${model}.${field}`, data);
  }

  render() {
    const {
      data, field, readOnly, valid,
    } = this.props;
    return (
      <div>
        <CKEditor
          editor={ClassicEditor}
          config={
            {
              // removePlugins: [
              //   'Image',
              //   'ImageCaption',
              //   'ImageStyle',
              //   'ImageTextAlternative',
              //   'ImageToolbar',
              //   'ImageUpload',
              //   'MediaEmbed',
              // ],
              link: {
                addTargetToExternalLinks: true,
              },
              toolbar: [
                'heading',
                '|',
                'bold',
                'italic',
                'link',
                'bulletedList',
                'numberedList',
                'blockQuote',
                'insertTable',
                'undo',
                'redo',
              ],
            }
          }
          data={data}
          onChange={this.onChange}
          disabled={readOnly}
        />
        <div className="form-group sr-only">
          <Control type="hidden" model={`.${field}`} />
        </div>
        <div>
          character count:
          {' '}
          {data.length}
          /4000
        </div>
        <Errors
          model={`.${field}`}
          component="div"
          wrapper={({ children }) => <div className={classnames({ 'invalid-feedback': true, 'haz-associated-table-error': !valid })}>{children}</div>}
        />
      </div>
    );
  }
}

HtmlEditorUnwrapped.propTypes = {
  model: PropTypes.string.isRequired,
  data: PropTypes.string.isRequired,
  change: PropTypes.func.isRequired,
  field: PropTypes.string.isRequired,
  readOnly: PropTypes.bool,
  valid: PropTypes.bool.isRequired,
};

HtmlEditorUnwrapped.defaultProps = {
  readOnly: false,
};


const mapStateToProps = (state, { model, field }) => ({
  data: state.getIn([model, field]) ? state.getIn([model, field]) : '',
  valid: state.get('forms')[model][field].valid,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  change: actions.change,
}, dispatch);

export const HtmlEditor = connect(mapStateToProps, mapDispatchToProps)(HtmlEditorUnwrapped);
